import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Pages.css';

const Profile = ({ user }) => {
  const navigate = useNavigate();
  const profile = user || JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <div className="page-container" style={{ maxWidth: 640 }}>
      <div className="page-header">
        <h1>My Profile</h1>
      </div>

      <div className="card">
        <div className="card-header">Account</div>
        <p><strong>Name:</strong> {profile.name || <span className="text-muted">—</span>}</p>
        <p><strong>Email:</strong> {profile.email}</p>
        <p><strong>Phone:</strong> {profile.phone || <span className="text-muted">—</span>}</p>
        <p style={{ marginBottom: 0 }}>
          <strong>Account type:</strong>{' '}
          <span className={`badge badge-${profile.role}`}>{profile.role}</span>
        </p>
      </div>

      {(profile.role === 'practitioner' || profile.role === 'admin') && (
        <div className="card">
          <div className="card-header">Public Profile</div>
          <p className="text-muted" style={{ marginTop: -8, marginBottom: 14 }}>
            Manage the bio, photo, and social links shown to clients alongside your services.
          </p>
          <button className="btn btn-secondary btn-sm" onClick={() => navigate('/practitioner/profile')}>
            Edit public bio &amp; social links →
          </button>
        </div>
      )}

      <div className="card">
        <div className="card-header">Legal</div>
        <p className="text-muted" style={{ marginTop: -8, marginBottom: 14 }}>
          How Had Collective, LLC handles your information, and the terms of using this platform.
        </p>
        <div style={{ display: 'flex', gap: 10 }}>
          <a className="btn btn-secondary btn-sm" href="/legal/privacy">Privacy Policy</a>
          <a className="btn btn-secondary btn-sm" href="/legal/terms">Terms &amp; Conditions</a>
        </div>
      </div>
    </div>
  );
};

export default Profile;
